<div>
  @if (label && !editMode) {
    <span
      [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
      >
      {{label}}
    </span>
  }
  @if (!editMode) {
    <div class="selectPreviewData"
      (click)="editMode= !editMode"
      (keydown.space)="editMode= !editMode"
      (keydown.enter)="editMode= !editMode"
      [ngClass]="{'defaultPlaceHolder': !data.label && defaultPlaceHolder}"
      aria-label='click to edit'
      >
      {{data.label || defaultPlaceHolder}}
    </div>
  }
  @if (editMode) {
    <mat-form-field appearance="outline">
      @if (label) {
        <mat-label>{{label}}</mat-label>
      }
      <mat-select [(ngModel)]="tempValue"
        (selectionChange)="onFocusOut()" name="selectWithSearch">
        @for (item of items; track item) {
          <mat-option [value]="item.value" (click)="editOff()">
            {{item.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
